export default "\r\n        <span *ngIf =\"value\"  class=\"pi pi-check\"></span>\r\n\r\n        <span *ngIf = \"!value\"  class=\"pi pi-times\"></span>\r\n";